import { jsxs as u, jsx as p } from "react/jsx-runtime";
import c from "dayjs";
import m from "./select-time-slot-for-trailer.module.less.js";
import { FilterChip as N } from "../../../../../components/elements/filter-chip/filter-chip.js";
import { useState as Y } from "react";
import { useTranslation as w } from "react-i18next";
import { isArrayWithItems as P } from "../../../../../helpers/array-helper.js";
import { dayjsToDateTimeString as h } from "../../../../../helpers/date-helper.js";
import "../../../../../contexts/global-context.js";
import "motion/react";
import { PrimaryButton as j } from "../../../../../components/elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import { LinkButton as U } from "../../../../../components/elements/link/link.js";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import { InputElementTopSection as D } from "../../../../../components/form-elements/components/input-element-top-section/input-element-top-section.js";
import { AlertSummary as V } from "../../../../../components/elements/alert-summary/alert-summary.js";
import "usehooks-ts";
import "react-countup";
import "embla-carousel-react";
import "react-loading-skeleton";
/* empty css                                                                   */
import "@tanstack/react-query";
import "lodash-es";
import "../../../../../components/form-elements/input/input.js";
import "react-hook-form";
import "../../../../../components/form-elements/file-upload/file-upload.js";
import "../../../../../components/form-elements/select/select.js";
import "@radix-ui/react-slider";
import "../../../../../components/blocks/customer-service/company-forms.js";
import "../../../../../labels/i18n.js";
import "body-scroll-lock";
import "@radix-ui/react-visually-hidden";
import G from "../../../../../events/event-aggregator.js";
import { EVENT as X } from "../../../../../events/event.js";
import "supercluster";
/* empty css                                */
const I = (e, r) => {
  const t = r.substring(0, 2), o = Number.parseInt(t), i = r.substring(3, 5), f = Number.parseInt(i);
  return e.set("hour", o).set("minute", f);
}, S = (e, r, t) => {
  const o = I(e, r);
  let i = I(e, t);
  return o.isSame(i, "minute") && (i = i.set("hour", 23).set("minute", 59)), {
    open: o,
    close: i
  };
}, M = (e, r) => {
  const t = r.openingHours.specialHours.find(
    (i) => i.date && c(i.date).isSame(e, "date")
  );
  if (t)
    return S(e, t.open, t.close);
  const o = e.get("day");
  if (o > -1 && o < 5)
    return S(
      e,
      r.openingHours.regularHours.mondayToFriday.open,
      r.openingHours.regularHours.mondayToFriday.close
    );
  if (o === 5)
    return S(
      e,
      r.openingHours.regularHours.saturday.open,
      r.openingHours.regularHours.saturday.close
    );
  if (o === 6)
    return S(
      e,
      r.openingHours.regularHours.sunday.open,
      r.openingHours.regularHours.sunday.close
    );
}, g = (e, r) => {
  if (!e || !r)
    return [];
  let t = c(e);
  const o = c(r), i = new Array();
  for (; !t.isAfter(o, "minute"); )
    i.push(c(t)), t = t.add(30, "minute");
  return i;
}, K = (e, r) => {
  for (const t of e.freeTimeSlots)
    if (O(r, t))
      return !0;
  return !1;
}, q = (e, r) => {
  for (const t of e.freeTimeSlots)
    if (b(r, t))
      return !0;
  return !1;
}, O = (e, r) => {
  const t = c(r.from), o = c(r.to), i = e.add(30, "minute");
  return !!((e.isSame(t, "minute") || e.isAfter(t, "second")) && (i.isSame(o, "minute") || i.isBefore(o, "second")));
}, b = (e, r) => {
  const t = c(r.from), o = c(r.to), i = e.subtract(30, "minute");
  return !!((i.isSame(t, "minute") || i.isAfter(t, "second")) && (e.isSame(o, "minute") || e.isBefore(o, "second")));
}, z = (e, r) => r ? e.isAfter(r, "minute") : !1, J = (e, r, t) => {
  if (t) {
    const o = r.freeTimeSlots.find(
      (i) => O(t, i)
    );
    return !!(o && z(e, t) && b(e, o));
  }
  return q(r, e);
}, y = (e, r) => r.isAfter(e, "minute"), Wr = ({
  closeDrawer: e,
  dispatch: r,
  trailer: t,
  station: o,
  rentalStartDate: i,
  rentalEndDate: f,
  selectedFromSlot: a,
  selectedToSlot: l,
  rentalPrice: v
}) => {
  const { t: s } = w(), [R, C] = Y(!1), d = c(), A = M(i, o), H = M(f, o), F = g(
    A?.open,
    A?.close
  ), W = g(
    H?.open,
    H?.close
  ), k = (n) => {
    r({
      type: "SELECT_FROM_TIMESLOT",
      payload: { timeSlot: h(n) }
    });
  }, x = (n) => {
    r({
      type: "SELECT_TO_TIMESLOT",
      payload: { timeSlot: h(n) }
    });
  }, L = a && l, T = R && !L, B = () => {
    R || C(!0), L && (G.publish(X.TRACK_EVENT, {
      event: "book_trailer_submit",
      station: o.name,
      pickup_date: a.format("YYYY-MM-DD"),
      return_date: l.format("YYYY-MM-DD"),
      trailer_type: t.title,
      est_price: parseInt(t.fromPrice),
      final_price: v,
      pickup_time: a.format("HH:mm"),
      return_time: l.format("HH:mm")
    }), r({
      type: "CHANGE_STEP",
      payload: { step: "PERSONAL_INFORMATION" }
    }));
  }, E = [];
  return T && !a && E.push({ text: s("TRAILER_RENTAL_ERROR_MUST_SELECT_FROM_TIMESLOT") }), T && !l && E.push({ text: s("TRAILER_RENTAL_ERROR_MUST_SELECT_TO_TIMESLOT") }), /* @__PURE__ */ u("div", { className: m.wrapper, children: [
    /* @__PURE__ */ u("div", { className: m.dateWrapper, children: [
      /* @__PURE__ */ u("h5", { children: [
        s("TRAILER_RENTAL_SEARCH_STARTDATE_LABEL"),
        " ",
        s("DATE_PREFIX"),
        " ",
        i.format("D MMMM")
      ] }),
      /* @__PURE__ */ u("div", { className: [m.dateAndTimeSelection, T && !a ? m.error : ""].join(" "), children: [
        /* @__PURE__ */ p(
          D,
          {
            label: s("TIME"),
            errorText: T && !a ? s("TRAILER_RENTAL_ERROR_MUST_SELECT_TIMESLOT") : void 0
          }
        ),
        /* @__PURE__ */ p("div", { className: m.timeSlotWrapper, children: F.map((n) => {
          const _ = a && a.isSame(n, "minute");
          return /* @__PURE__ */ p(
            N,
            {
              onClick: () => k(n),
              label: n.format("HH:mm"),
              isSelected: _,
              isDisabled: !y(d, n) || !K(t, n)
            },
            "from" + n.format("HH:mm")
          );
        }) })
      ] })
    ] }),
    /* @__PURE__ */ u("div", { className: m.dateWrapper, children: [
      /* @__PURE__ */ u("h5", { children: [
        s("TRAILER_RENTAL_SEARCH_ENDDATE_LABEL"),
        " ",
        s("DATE_PREFIX"),
        " ",
        f.format("D MMMM")
      ] }),
      /* @__PURE__ */ u("div", { className: [m.dateAndTimeSelection, T && !l ? m.error : ""].join(" "), children: [
        /* @__PURE__ */ p(
          D,
          {
            label: s("TIME"),
            errorText: T && !l ? s("TRAILER_RENTAL_ERROR_MUST_SELECT_TIMESLOT") : void 0
          }
        ),
        /* @__PURE__ */ p("div", { className: m.timeSlotWrapper, children: W.map((n) => {
          const _ = l && l.isSame(n, "minute");
          return /* @__PURE__ */ p(
            N,
            {
              onClick: () => x(n),
              label: n.format("HH:mm"),
              isSelected: _,
              isDisabled: !y(d, n) || !J(n, t, a)
            },
            "from" + n.format("HH:mm")
          );
        }) })
      ] })
    ] }),
    /* @__PURE__ */ u("div", { className: m.buttonErrorWrapper, children: [
      P(E) && /* @__PURE__ */ p(V, { type: "error", heading: s("ERROR_MISSING_INFORMATION"), messages: E }),
      /* @__PURE__ */ u("div", { className: m.buttonWrapper, children: [
        /* @__PURE__ */ p(
          j,
          {
            className: m.nextButton,
            label: s("GO_NEXT_STEP"),
            onClick: B,
            iconRight: "ui-icon-arrow-right"
          }
        ),
        /* @__PURE__ */ p(
          U.Secondary,
          {
            className: m.backButton,
            label: s("BACK"),
            onClick: e,
            iconLeft: "ui-icon-arrow-left"
          }
        )
      ] })
    ] })
  ] });
};
export {
  Wr as SelectTimeSlotForTrailer
};
